import { Component, h } from 'preact'
import { Article, ArticleEdit, GroupedEdits } from './types'
import ArticleEditList from './ArticleEditList'
import ArticleHeader from './ArticleHeader'
import Content from '../common/Content'
import axios from 'axios'
import tracker from '../../components/tracker/publish'

type Props = {
  article: Article
}

type State = {
  edits: GroupedEdits,
  selectedEdit: string | undefined,
  latestEdit: ArticleEdit | undefined,
  publishedAt: string | null
}

class ArticleVersions extends Component<Props, State> {
  article: Article

  constructor ({ article }: Props) {
    super()

    this.state = {
      edits: {
        published: [],
        draft: []
      },
      selectedEdit: undefined,
      latestEdit: undefined,
      publishedAt: null
    }

    this.article = article
    this.showEditContent = this.showEditContent.bind(this)
  }

  async componentDidMount (): Promise<void> {
    try {
      const res = await axios.get(`/article/${this.article.id}/contentEdits`)
      if (!res.data) {
        return
      }
      const edits = res.data.edits.reverse()
      this.setState({
        selectedEdit: edits[0].edited_at,
        latestEdit: edits[0],
        publishedAt: res.data.published_at
      })
      this.setGroupedEdits(edits)
      this.trackVersionHistoryViewed()
    } catch (e) {
      console.log(e)
    }
  }

  setGroupedEdits (edits: ArticleEdit[]) {
    const groupedEdits = { ...this.state.edits }
    edits.map(edit => {
      const editGroup = !this.state.publishedAt || edit.edited_at < this.state.publishedAt ? 'draft' : 'published'
      groupedEdits[editGroup] = [...groupedEdits[editGroup], edit]
    })
    this.setState({
      edits: groupedEdits
    })
  }

  showEditContent (editedAt: string) {
    this.setState({ selectedEdit: editedAt })
  }

  getSelectedEdit () {
    const { edits, selectedEdit } = this.state

    if (!selectedEdit) return

    return [...edits.published, ...edits.draft].find(edit =>
      edit.edited_at === selectedEdit
    )
  }

  trackVersionHistoryViewed () {
    tracker.trackEvent('userevent', {
      'type': 'Article Version History Viewed',
      'article_id': this.article.id,
      'user_id': window.inSidedData.user.userid
    })
  }

  render (_: Props, { edits, selectedEdit, latestEdit }: State) {
    const { title, url } = this.article
    const selectedEditObject = this.getSelectedEdit()

    return (
      <div class='article-versions'>
        <ArticleHeader
          title={title}
          editedAt={latestEdit && latestEdit.edited_at}
          editedBy={latestEdit && latestEdit.edited_by}
          url={url}
        />
        <div class='article-versions__content-edit-list-wrapper'>
          { selectedEditObject && <Content
            content={selectedEditObject.content}
            className='article-versions__content'
            isControl
          /> }
          <ArticleEditList
            edits={edits}
            latestEdit={latestEdit && latestEdit.edited_at}
            onItemClicked={this.showEditContent}
            selectedEdit={selectedEdit}
          />
        </div>
      </div>
    )
  }
}

export default ArticleVersions
